import { setting } from '@/storage';
import { Self } from '@/vue-core';
import { defineComponent, reactive, onMounted } from '@vue/composition-api';
export default defineComponent({
    props: {},
    setup(props, context) {
        let self = new Self(context);
        // =================
        //
        // state
        //
        let $ = reactive({
            page: 0,
            view: false,
            items: [
                {
                    src: '/images/tutorials-1.jpg',
                    text: '建立農場與填寫農場資訊。'
                },
                {
                    src: '/images/tutorials-2.jpg',
                    text: '只要每天花上十分鐘拍照、記帳與建立事件，這樣的一個單位稱之為"照片"。'
                },
                {
                    src: '/images/tutorials-3.jpg',
                    text: '每天11~12點，將藉由雲端自動封存照片，並產生客戶端資訊與報表。'
                },
                {
                    src: '/images/tutorials-4.jpg',
                    text: '透過QRCode或網址將照片發放禮盒、社群軟體、電子商城上。'
                }
            ]
        });
        // =================
        //
        // mounted
        //
        onMounted(() => {
            $.view = !setting.getFirstIn();
            setting.setFirstIn();
        });
        // =================
        //
        // done
        //
        return {
            $
        };
    }
});
